import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getLoyalty, earnLoyalty as apiEarn, trackEvent } from "@/lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const readLS = (k, fb) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch { return fb; }
};

export const StoreProvider = ({ children }) => {
  const [guestId] = useState(() => {
    let g = localStorage.getItem("lvx_guest");
    if (!g) { g = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random())); localStorage.setItem("lvx_guest", g); }
    return g;
  });

  const [cart, setCart] = useState(() => readLS("lvx_cart", []));
  const [wishlist, setWishlist] = useState(() => readLS("lvx_wishlist", []));
  const [recent, setRecent] = useState(() => readLS("lvx_recent", []));
  const [loyalty, setLoyalty] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [stylistOpen, setStylistOpen] = useState(false);
  const [sizeFinderOpen, setSizeFinderOpen] = useState(false);

  useEffect(() => localStorage.setItem("lvx_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("lvx_wishlist", JSON.stringify(wishlist)), [wishlist]);
  useEffect(() => localStorage.setItem("lvx_recent", JSON.stringify(recent)), [recent]);

  const refreshLoyalty = useCallback(async () => {
    try { setLoyalty(await getLoyalty(guestId)); } catch {}
  }, [guestId]);

  useEffect(() => { refreshLoyalty(); }, [refreshLoyalty]);

  const earn = useCallback(async (action) => {
    try { const data = await apiEarn({ guest_id: guestId, action }); setLoyalty(data); return data; } catch {}
  }, [guestId]);

  const addToCart = (item) => {
    setCart((prev) => {
      const idx = prev.findIndex((c) => c.variantId === item.variantId);
      if (idx >= 0) { const cp = [...prev]; cp[idx] = { ...cp[idx], quantity: cp[idx].quantity + item.quantity }; return cp; }
      return [...prev, item];
    });
    setCartOpen(true);
    trackEvent({ guest_id: guestId, event: "add_to_cart", handle: item.handle });
  };
  const updateQty = (variantId, quantity) =>
    setCart((prev) => quantity <= 0 ? prev.filter((c) => c.variantId !== variantId)
      : prev.map((c) => (c.variantId === variantId ? { ...c, quantity } : c)));
  const removeFromCart = (variantId) => setCart((prev) => prev.filter((c) => c.variantId !== variantId));
  const clearCart = () => setCart([]);

  const toggleWishlist = (handle) => {
    setWishlist((prev) => prev.includes(handle) ? prev.filter((h) => h !== handle) : [...prev, handle]);
    trackEvent({ guest_id: guestId, event: "wishlist", handle });
  };
  const isWished = (handle) => wishlist.includes(handle);

  const pushRecent = (handle) => {
    setRecent((prev) => [handle, ...prev.filter((h) => h !== handle)].slice(0, 8));
    trackEvent({ guest_id: guestId, event: "view", handle });
  };

  const cartCount = cart.reduce((s, c) => s + c.quantity, 0);
  const subtotal = cart.reduce((s, c) => s + c.price * c.quantity, 0);

  return (
    <StoreContext.Provider value={{
      guestId, cart, cartCount, subtotal, addToCart, updateQty, removeFromCart, clearCart,
      wishlist, toggleWishlist, isWished, recent, pushRecent,
      loyalty, refreshLoyalty, earn,
      cartOpen, setCartOpen, stylistOpen, setStylistOpen, sizeFinderOpen, setSizeFinderOpen,
    }}>
      {children}
    </StoreContext.Provider>
  );
};
